import IFilter from '../../interfaces/AceleraMagenta/index/IFilter'
import { IAceleraMagentaAnswer } from '../../interfaces/IAceleraMagentaAnswer'
import { IAceleraMagentaStore } from '../../interfaces/IAceleraMagentaStore'
import apiService from '../Api'

export default class AceleraMagentaService {
  async list(filter: IFilter) {
    return apiService.get('/acelera-magenta', {params: filter})
  }

  async getStep(id: number) {
    return apiService.get(`/acelera-magenta/get-step/${id}`)
  }

  async getResponses(id: number, step: number) {
    return apiService.get(`/acelera-magenta/get-responses/${id}/${step}`)
  }

  async getSteps(id: number) {
    return apiService.get(`/acelera-magenta/get-steps/${id}`)
  }

  async store(data: IAceleraMagentaStore) {
    return apiService.post('/acelera-magenta', data)
  }

  async update(id: number, data: IAceleraMagentaAnswer) {
    return apiService.put(`/acelera-magenta/${id}`, {answers: data})
  }

  async delete(id: number) {
    return apiService.delete(`/acelera-magenta/${id}`)
  }
}
